import React, { useEffect } from 'react';
import { getUrlParam } from 'libs/helper/utils';
import { useStoreWrapper } from 'stores/StoreHelper';
import { useLocation } from 'react-router-dom';
import CouponFilter from 'components/management/filters/CouponFilter';
import { AdminCouponDto, AdminUserCouponDto } from 'services/data-contracts';
import VoucherView from 'components/management/modals/VoucherView';
import VoucherEdit from 'components/management/modals/VoucheEdit';
import { observer } from 'mobx-react-lite';
import NoContents from 'components/commons/\bNoContents';
import CouponTable from 'components/management/tables/CouponTable';
import CouponEdit from 'components/management/modals/CouponEdit';
import CouponView from 'components/management/modals/CouponView';
const CouponPage = observer(() => {
  const { couponFilterStore, uiStore } = useStoreWrapper();

  const location = useLocation();

  const fetchCoupons = () => {
    const search = getUrlParam('searchKeyword');
    const page = getUrlParam('page');
    const size = getUrlParam('size');
    couponFilterStore.getCoupons({
      keyword: search || '',
      page: page ? parseInt(page) : undefined,
      size: size ? parseInt(size) : 20,
    });
  };

  const handleRowClick = (coupon: AdminUserCouponDto) => {
    uiStore?.modal.show({
      title: '쿠폰 상세',
      style: {
        maxWidth: '800px',
        height: 'auto',
        maxHeight: '80vh',
      },
      children: <CouponView coupon={coupon} />,
    });
  };

  const handleEditClick = (coupon?: AdminUserCouponDto) => {
    uiStore?.modal.show({
      title: coupon ? '쿠폰 수정' : '쿠폰 발행',
      style: {
        maxWidth: '800px',
        height: '100%',
        maxHeight: '80vh',
      },
      children: <CouponEdit coupon={coupon} />,
      onConfirmed: () => {
        fetchCoupons();
      },
    });
  };

  useEffect(() => {
    fetchCoupons();
  }, [location.search]);

  return (
    <div>
      <CouponFilter
        onClickAdd={() => {
          handleEditClick();
        }}
      />
      <CouponTable
        coupons={couponFilterStore?.filteredCoupons}
        onRowClick={handleRowClick}
        onEditClick={handleEditClick}
      />
      <NoContents>표시할 데이터가 없습니다.</NoContents>
    </div>
  );
});

export default CouponPage;
